import PageLayout from "../components/UI/Layout/PageLayout";
import ContentLayout from "../components/UI/Layout/ContentLayout.tsx";
import HeaderLayout from "../components/UI/Layout/HeaderLayout.tsx";
import { Tabs } from "../components/UI/Tabs/Tabs";
import Callout from "../components/UI/Callout";
// @ts-expect-error pure js
import useAuth from "../hooks/use-auth.js";
import PointeTab from "../components/Compta/PointeTab";
import JournalTab from "../components/Compta/JournalTab";
import GrandLivreTab from "../components/Compta/GrandLivreTab";
import BalanceTab from "../components/Compta/BalanceTab";
import MandatsTab from "../components/Compta/MandatsTab";
import CloturesTab from "../components/Compta/CloturesTab";
import ExportsTab from "../components/Compta/ExportsTab";

export default function ComptabilitePage() {
  const { isPro } = useAuth();

  return (
    <PageLayout isBailleur>
      <ContentLayout
        header={
          <HeaderLayout
            title="Comptabilité"
            breadcrumb={[
              { label: "Tableau de bord", to: "/bailleur" },
              { label: "Comptabilité" },
            ]}
          />
        }
        body={
          !isPro ? (
            <div className="content">
              <Callout variant="info" title="Réservé à l'offre professionnelle">
                La comptabilité mandants (journal en partie double, balance,
                état de pointe, registre des mandats) est réservée aux comptes
                professionnels. Contactez-nous pour activer l'offre pro.
              </Callout>
            </div>
          ) : (
            <Tabs id="compta" defaultValue="pointe">
              <div className="container bg-blue paddingT10 border-blue">
                <div className="content">
                  <Tabs.List>
                    <Tabs.Tab value="pointe">Trésorerie</Tabs.Tab>
                    <Tabs.Tab value="journal">Journal</Tabs.Tab>
                    <Tabs.Tab value="grand-livre">Grand livre</Tabs.Tab>
                    <Tabs.Tab value="balance">Balance</Tabs.Tab>
                    <Tabs.Tab value="mandats">Mandats</Tabs.Tab>
                    <Tabs.Tab value="clotures">Clôtures</Tabs.Tab>
                    <Tabs.Tab value="exports">Exports</Tabs.Tab>
                  </Tabs.List>
                </div>
              </div>
              <div className="blueSpace"></div>
              <div className="content">
                <Tabs.Panel value="pointe">
                  <PointeTab />
                </Tabs.Panel>
                <Tabs.Panel value="journal">
                  <JournalTab />
                </Tabs.Panel>
                <Tabs.Panel value="grand-livre">
                  <GrandLivreTab />
                </Tabs.Panel>
                <Tabs.Panel value="balance">
                  <BalanceTab />
                </Tabs.Panel>
                <Tabs.Panel value="mandats">
                  <MandatsTab />
                </Tabs.Panel>
                <Tabs.Panel value="clotures">
                  <CloturesTab />
                </Tabs.Panel>
                <Tabs.Panel value="exports">
                  <ExportsTab />
                </Tabs.Panel>
              </div>
            </Tabs>
          )
        }
      />
    </PageLayout>
  );
}
